export const setCookie = (cname, cvalue, exdays) => {
  let path;
  if (process.env['NODE_ENV'] === "development") {
    path = 'dev-dashboard-sandbox.markaaz';
  } else {
    path = 'test-dashboard-sandbox.markaaz';
  }
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + `;path="/${path}"`
}

export const getCookie = cname => {
  const name = cname + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const checkCookie = (cname, cvalue) => {
  const storedCValue = getCookie(cname)
  if (cvalue === storedCValue) {
    // console.log('helper-checkCookie-cvalue-', {cvalue, storedCValue})
    return true
  } else {
    // console.log('helper-checkCookie-cvalue-false',)
    return false
  }
}

export const sleep = time =>
  new Promise((res, rej) =>
    setTimeout(() => {
      res(true)
    }, time),
  )

export const validateEmail = email => {
  var re = /\S+@\S+\.\S+/
  return re.test(email)
}

export const validatePassword = password => {
  var re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!_%*?&]{8,}$/
  return re.test(password)
}

export const getOperatingSystem = window => {
  let operatingSystem = 'Not known'
  if (window.navigator.appVersion.indexOf('Win') !== -1) {
    operatingSystem = 'Windows OS'
  }
  if (window.navigator.appVersion.indexOf('Mac') !== -1) {
    operatingSystem = 'MacOS'
  }
  if (window.navigator.appVersion.indexOf('X11') !== -1) {
    operatingSystem = 'UNIX OS'
  }
  if (window.navigator.appVersion.indexOf('Linux') !== -1) {
    operatingSystem = 'Linux OS'
  }

  return operatingSystem
}

export const getDeviceInformation = window => {
  let deviceName = 'notDetected'
  if (window.navigator.userAgent.includes('iPhone')) {
    deviceName = 'iPhone'
  }
  if (window.navigator.userAgent.includes('Android')) {
    deviceName = 'Android'
  }
  if (window.navigator.userAgent.includes('iPad')) {
    deviceName = 'iPad'
  }
  if (window.navigator.userAgent.includes('Windows')) {
    deviceName = 'WindowsDevice'
  }

  return deviceName
}

export const getBrowser = window => {
  let currentBrowser = 'Not known'
  if (window.navigator.userAgent.indexOf('Chrome') !== -1) {
    currentBrowser = 'Google Chrome'
  } else if (window.navigator.userAgent.indexOf('Firefox') !== -1) {
    currentBrowser = 'Mozilla Firefox'
  } else if (window.navigator.userAgent.indexOf('MSIE') !== -1) {
    currentBrowser = 'Internet Exployer'
  } else if (window.navigator.userAgent.indexOf('Edge') !== -1) {
    currentBrowser = 'Edge'
  } else if (window.navigator.userAgent.indexOf('Safari') !== -1) {
    currentBrowser = 'Safari'
  } else if (window.navigator.userAgent.indexOf('Opera') !== -1) {
    currentBrowser = 'Opera'
  } else if (window.navigator.userAgent.indexOf('Opera') !== -1) {
    currentBrowser = 'YaBrowser'
  } else {
    console.log('Others')
  }

  return currentBrowser
}
